import { Loader } from "@vds/loaders";
import React, { lazy, useState, useEffect, useMemo, useContext, useCallback } from "react";
import { Table, TableHead, TableBody, TableRow, Cell, TableHeader } from "@vds/tables";
import { css } from "@emotion/react";
import { FlexRow, SmallText, Spacer, SLNotification } from "../../components/core/utility";
import { Button, TextLink } from "@vds/buttons";
import { groupBy } from "lodash";
import { bundleList, deleteBundle } from "../../services/C4S Decommission - Replacement/bundleList";
import { ViewVehicleList } from "../../services/C4S Decommission - Replacement/viewVehicleList";
import {
  ViewVehicleListByAddress,
  postApplyActions,
  ViewVehicleListByAddressOnly,
} from "../../services/C4S Decommission - Replacement/viewVehicleListByAddress";
import { OrderShippingSummaryAccordion } from "./OrderShippingSummaryAccordion";
import { generate } from "shortid";
import useOutsideClick from "../../customHook/use-outside-click";
import styled from "styled-components";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Dropdown } from "primereact/dropdown";
import { Icon } from "@vds/icons";
import startBulk from "../../assets/icons/startBulk.png";
import { handleAddPage, switchTab } from "./utils";
import { AddVehicleAssignmentMetadata } from "./AddVehicleAssignment";
import { AddAssetAssignmentMetadata } from "./AddAssetAssignment";
import { EditVehicleWTAMetadata } from "./EditVehicleWTAMetadata";
import AddKeyFobsModal from "./KeyFob/AddKeyFobsModal";
import { ASSIGN_HARDWARE_LIST_COLS } from "../../constants/AssignHardwareConstants";
import isEmpty from "lodash/isEmpty";
import { useToValidateKeyFobsQuantity } from "../../services/workticket/useToValidateKeyFobsQuantity";
import { C4SContext } from "../../context/c4sContext";
import InfoModal from "./InfoModal";
import DeleteModal from "./DeleteModal";
import { Breadcrumbs, BreadcrumbItem } from "@vds/breadcrumbs";
import { messageBus } from "../../../utility/messageBus";
import CustomDropdownWithHeaders from "./AssignHardwareComponents/CustomDropdownWithHeaders";
import { AccordionStyle } from "../VehicleManagement/VehicleDetailsTableComponent";
import onDemand from "../../assets/icons/on_demand.svg";
import { getAllReasonsData } from "../../services/C4S Decommission - Replacement/getAllReasonsData";

/** Action values that require a priority-change reason dropdown */
const PRIORITY_ACTIONS = ["priority-1", "priority-2", "priority-3"];
const getActionValue = (action) => (typeof action === "object" && action !== null ? action.value : action);
const getActionType = (action) => (typeof action === "object" && action !== null ? action.action : null);
const isPriorityAction = (action) => PRIORITY_ACTIONS.includes(getActionValue(action));
/** Only priority-2 and priority-3 require a reason dropdown */
const PRIORITY_ACTIONS_WITH_REASON = ["priority-2", "priority-3"];
const isPriorityActionWithReason = (action) => PRIORITY_ACTIONS_WITH_REASON.includes(getActionValue(action));
/** Delete vehicles action */
const DELETE_ACTION = "delete-vehicles";
const isDeleteAction = (action) => getActionValue(action) === DELETE_ACTION;
import { NewAssignHardwareGrid } from "./AssignHardwareComponents/NewAssignHardwareGrid";
import { DEVICE_TYPES, VEHICLE_STATUS } from "./AssignHardwareComponents/AssignHardwareConstants";
import AddressDropdown from "./AssignHardwareComponents/AddressDropdown";
import "./AddressModal.css"; // ✅ Modal styles
import AddressModal from "./AssignHardwareComponents/AddressModal"; // ✅ Extracted modal component

const isInIframe = () => {
  try {
    return window.location !== window.parent.location;
  } catch (e) {
    return true;
  }
};

const StyledIconContainer = styled.div`
  display: flex;
`;
const TableWrapper = styled.div`
  padding: 0 10px 0 16px;
  .p-datatable .p-datatable-tbody > tr {
    outline: none;
  }
  .p-datatable .p-datatable-header {
    padding-bottom: 0px !important;
    border-bottom: none !important;
  }
`;
const IconWrapper = styled.div`
  height: 24px;
  width: 24px;
  align-items: center;
  cursor: pointer;
  // margin-right: 10px;
  display: flex;
  margin-left: 2px;
  margin-bottom: 2px;
`;
const TextWrapper = styled.div`
  // height: 24px;
  // width: 24px;
  align-items: center;
  cursor: pointer;
  display: flex;
  // margin-left: 2px;
  // margin-bottom: 2px;
`;
const CustomTableHeader = css`
  margin-bottom: 0px;
  table-layout: fixed;
  thead {
    border-bottom: none;
    margin-bottom: 1px;
    th {
      padding: 0;
    }
  }
  td {
    padding: 2px 2px 2px 0px;
  }
`;

const TextLinkWrapper = styled(TextLink)`
  a:hover {
    color: #4c9aff;
  }
`;
export const AccordionWrapper = styled.div`
  // padding-top: 2.5rem;
  .p-accordion .p-accordion-tab .p-accordion-header .p-accordion-header-link,
  .p-accordion .p-accordion-tab .p-accordion-header:hover .p-accordion-header-link,
  .p-accordion .p-accordion-tab .p-accordion-header .p-accordion-header-link {
    color: #000000;
    // border: none;
    padding: 0.5rem;
    background: lightgray;
    // box-shadow: unset;
    border-radius: 10px !important;
    margin-bottom: 0.6rem;
  }
  padding-top: 0.8rem;
  // padding-bottom: 0.8rem;

  .p-accordion .p-accordion-content {
    padding: 0rem;
    // border: none;
    padding-bottom: 0.8rem;
  }
  .p-accordion-header-text {
    font-weight: 500;
    font-family: Verizon-NHG-eDS;
    font-size: 0.8rem;
    border-radius: 10px;
  }
  .p-accordion-toggle-icon {
    order: 1;
    margin-left: auto;
  }
`;

// Helper function to render vehicle status with bold numbers
const renderVehicleStatus = (material) => {
  const notEntered =
    Number(material[0].Quantity) -
    (Number(material[0].vehicle?.ready) + Number(material[0].vehicle?.warnings) + Number(material[0].vehicle?.completed));
  const ready = Number(material[0].vehicle?.ready) || 0;
  const warnings = Number(material[0].vehicle?.warnings) || 0;
  const falloutValue = Number(material[0].fallout) || 0;
  const remaining = notEntered - falloutValue >= 0 ? notEntered - falloutValue : 0;
  const parts = [
    { value: remaining, label: "Remaining" },
    { value: warnings, label: "Needs Attention" },
    { value: ready, label: "Ready" },
  ];
  return parts.map((part, idx) => (
    <span key={idx}>
      <b>{part.value}</b> {part.label}
      {idx < parts.length - 1 ? <span>{"\u00A0\u00A0\u00A0\u00A0"}</span> : null}
    </span>
  ));
};

const formatAddress = (shippingInfo) => {
  const { address, address1, city, stateCode, zipCode, country } = shippingInfo;
  const addr2Part = address1 ? `, ${address1}` : "";
  return `${address}${addr2Part}, ${city}, ${stateCode} ${zipCode}, ${country}`;
};

const AccordionTabContent = ({
  assetType,
  vehicleList,
  material,
  data,
  editVehicle,
  isVehicleEditable,
  selectedBundleIdForBulkAction,
  selectedAction,
  handleBulkVehicleSelection,
  deleteRow,
  selectedVehicleIds,
  selectedAddress,
}) => {
  const installTypeMap = useMemo(() => {
    return material.reduce((acc, item) => {
      return { ...acc, [item.SAPProductID]: item.InstallationType };
    }, {});
  }, [material]);

  // Filter rows based on asset type - for Vehicle type, show all; for Asset type, filter out KEYFOBs
  const filteredRows = useMemo(() => {
    if (assetType === "Vehicle") {
      return vehicleList;
    }
    return vehicleList?.filter((row) => row.deviceType !== "KEYFOB");
  }, [assetType, vehicleList]);

  // Get the composite key for this accordion tab
  const compositeKey = `${data.addressId}-${data.contactId}`;

  // Get the selected IDs for this specific address
  const initialSelectedIds = selectedVehicleIds?.[compositeKey] || [];

  // Helper function to determine if action is address change type
  const isAddressChangeAction = useCallback((action) => {
    return action?.value === "change-installation" || action?.value === "change-shipping";
  }, []);
  // Helper function to determine if bulk action is selected
  const getIsBulkActionSelected = useCallback(() => {
    if (!selectedAction) return false;

    // For regular actions (not address changes), return true if action exists
    if (!isAddressChangeAction(selectedAction)) {
      return true;
    }

    // For address change actions, return true only if an address is also selected
    return !!selectedAddress;
  }, [selectedAction, selectedAddress, isAddressChangeAction]);
  // Unified action icon renderer
  const renderActionIcon = useCallback(
    (row) => {
      const isDisabled = !!selectedBundleIdForBulkAction;
      const isKeyFob = row.deviceType === DEVICE_TYPES.KEYFOB;
      const isAsset = row.deviceType === DEVICE_TYPES.ASSET;

      // Determine if delete is enabled and delete type
      let isDeleteEnabled = false;
      let deleteType = "";

      if (isKeyFob) {
        isDeleteEnabled = row?.materialMapping?.[0]?.enabled;
        deleteType = "Delete Key Fob";
      } else if (isAsset) {
        const isSubmitted = row?.materialMapping?.[0]?.status?.toLowerCase() === "submitted";
        isDeleteEnabled = !isSubmitted;
        deleteType = "Delete Asset";
      } else {
        // Vehicle
        const allCancelled = row?.materialMapping?.every((material) => material?.wtstatus?.toLowerCase() === "cancelled");
        isDeleteEnabled = !allCancelled && row?.materialMapping?.every((material) => !material?.lineType);
        deleteType = "Delete Vehicle";
      }

      if (!isDeleteEnabled) {
        return null;
      }

      return (
        <FlexRow css={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
          <div
            onClick={() => {
              if (!isDisabled) {
                deleteRow(row, deleteType);
              }
            }}
            style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}
          >
            <Icon
              className="trash-icon"
              aria-label="Delete"
              alt="delete-icon"
              name="trash"
              size="medium"
              color={isDisabled ? "#C4C4C4" : "#000000"}
              style={{ cursor: isDisabled ? "not-allowed" : "pointer", outline: "none" }}
            />
          </div>
        </FlexRow>
      );
    },
    [selectedBundleIdForBulkAction, deleteRow]
  );

  // Common props for NewAssignHardwareGrid
  const commonGridProps = {
    columns: ASSIGN_HARDWARE_LIST_COLS,
    editVehicle,
    isVehicleEditable,
    bundleName: material[0].BundleName,
    bundleId: material[0].BundleId,
    shipGroupsData: data,
    assetType: material[0].AssetType,
    isBulkAction: !!selectedBundleIdForBulkAction,
    isBulkActionSelected: getIsBulkActionSelected(),
    handleBulkVehicleSelection,
    installTypeMap,
    renderActionIcon,
    initialSelectedIds,
  };
  return <NewAssignHardwareGrid {...commonGridProps} rows={filteredRows} />;
};

const AssignHardware = (props) => {
  const [isLoading, setLoader] = useState(false);
  const cspData = props?.cspData?.data?.data || {};
  const accountId = props?.cspData?.data?.data?.AccountID;
  let productData = groupBy(props?.cspData?.data?.data?.Product, "BundleId");
  const isWTA = sessionStorage.getItem("isWTA") === "true";
  const [cspDetailsData] = useState(Object.values(productData));
  const [productDetails, setProductDetails] = useState([]);
  const [vehiclleList, setVehicleList] = useState([]);
  const [notification, setNotification] = useState(null);
  const [activeIndex, setActiveIndex] = useState([]);
  const [modalOpened, setModalOpened] = useState(false);
  const [selectedVehicleData, setSelectedVehicleData] = useState(null);
  const [selectedBundleName, setSelectedBundleName] = useState("");
  const [selectedBundleId, setSelectedBundleId] = useState("");
  const [bundleData, setBundleData] = useState({});
  const [assetType, setAssetType] = useState("");
  const [isKeyFobsOpen, setKeyFobsOpen] = useState(false);
  const [selectedKeyFobRow, setSelectedKeyFobRow] = useState();
  const [selectedBundleIdForBulkAction, setSelectedBundleIdForBulkAction] = useState(null);
  const [selectedAction, setSelectedAction] = useState(null);
  const [showChangeAddress, setShowChangeAddress] = useState(false);
  const [typeOfChangeAddress, setTypeOfChangeAddress] = useState("");
  const [changeAddresses, setChangeAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  // ✅ Installation address modal state
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const [bulkVehiclesByAddress, setBulkVehiclesByAddress] = useState({});
  const [applyAction, setApplyAction] = useState(false);

  // Need to format the below states for better handling of bulk actions
  const [vehiclesAvailableForBulkAction, setVehiclesAvailableForBulkAction] = useState([]); //{ addressContactKey: "", vehicles: [] }
  const [selectedVehicles, setSelectedVehicles] = useState([]); //{ id: "", addressContactKey: "" }
  const [selectedVehicleIds, setSelectedVehicleIds] = useState(() => {
    // Initialize selectedVehicleIds with composite keys
    const initialSelectedVehicleIds = {};
    selectedVehicles.forEach((v) => {
      const compositeKey = `${v.addressId}-${v.contactId}`;
      if (!initialSelectedVehicleIds[compositeKey]) {
        initialSelectedVehicleIds[compositeKey] = [];
      }
      initialSelectedVehicleIds[compositeKey].push(v.id);
    });
    return initialSelectedVehicleIds;
  });
  const [addressModalLabel, setAddressModalLabel] = useState("");

  const { data, error, isLoading: isKeyFobLoading, validateKeyFobsQuantity } = useToValidateKeyFobsQuantity();
  // Priority-reason dropdown state (shown when a "Set to priority X" action is selected)
  const [priorityReasons, setPriorityReasons] = useState([]);
  const [selectedPriorityReason, setSelectedPriorityReason] = useState("");
  const [isPriorityReasonsLoading, setIsPriorityReasonsLoading] = useState(false);
  // Stores the getMaterialMappings response when a priority action is selected (called without vinList)
  const [bulkMaterialMappings, setBulkMaterialMappings] = useState(null);
  const [bulkFilterCompleted, setBulkFilterCompleted] = useState(false);

  const fetchPriorityReasons = async () => {
    setIsPriorityReasonsLoading(true);
    try {
      //const reasonsResponse = await getAllReasonsData("PRIORITY_REASONS");
      const reasonsResponse = await getAllReasonsData("RECOMM_CHANGE_REASONS");
      if (reasonsResponse?.status === 200 && reasonsResponse?.data?.data?.length) {
        setPriorityReasons(reasonsResponse.data.data);
      } else {
        setPriorityReasons([]);
        notify("Failed to fetch priority reasons", "error");
        setTimeout(() => setNotification(null), 5000);
      }
    } catch {
      setPriorityReasons([]);
      notify("Failed to fetch priority reasons", "error");
      setTimeout(() => setNotification(null), 5000);
    } finally {
      setIsPriorityReasonsLoading(false);
    }
  };

  useEffect(() => {
    if (isLoading || isEmpty(data)) return;

    if (isEmpty(error)) {
      data?.availableQty <= 0 ? setInfoModalOpened(true) : setKeyFobsOpen(true);
    } else {
      notify(error, "error");
    }
  }, [data, error, isKeyFobLoading]);

  const { cspDetails, workTicketInfo } = useContext(C4SContext);
  const [infoModalOpened, setInfoModalOpened] = useState(false);
  const [deleteModalOpened, setDeleteModalOpened] = useState(false);
  const [selectedRecordForDelete, setSelectedRecordForDelete] = useState(null);
  const [materialBundleList, setMaterialBundleList] = useState([]);

  useEffect(() => {
    const closeHandler = () => {
      setActiveIndex([]); // Resets the state to close all accordions
    };

    messageBus.on("closeAccordions", closeHandler);

    return () => {
      messageBus.off("closeAccordions", closeHandler);
    };
  }, []);
  useEffect(() => {
    let data = [];
    cspDetailsData.map((material) => {
      data.push(material[0].BundleId);
    });
    setMaterialBundleList(data);
    getBundleList(data);
  }, [activeIndex.length]);
  const closeInfoModal = () => {
    setInfoModalOpened(false);
  };

  // When an action is selected in bulk mode, call the filter API and store full response
  // keyed by addressId-contactId. All matching accordions are shown expanded simultaneously.
  useEffect(() => {
    if (selectedAction?.value === "change-shipping" || selectedAction?.value === "change-installation") {
      return;
    } else {
      if (!selectedAction || !selectedBundleIdForBulkAction) {
        setBulkVehiclesByAddress({});
        setBulkMaterialMappings(null);
        return;
      }
      // Reset priority reason state whenever action changes
      setSelectedPriorityReason("");
      // Fetch priority reasons only for priority-2 and priority-3
      if (isPriorityActionWithReason(selectedAction)) {
        fetchPriorityReasons();
      } else {
        setPriorityReasons([]);
        setBulkMaterialMappings(null);
      }

      // Find the material for the selected bundle
      const material = productDetails.find((m) => m[0]?.BundleId === selectedBundleIdForBulkAction);
      if (!material) return;

      const shipGroups = material[0]?.shipGroups;
      if (!shipGroups || !shipGroups.length) return;

      const addressContactList = shipGroups.map((sg) => ({
        addressId: sg.addressId,
        contactId: sg.contactId,
      }));

      const fetchFilteredVehicles = async () => {
        setBulkVehiclesByAddress({});
        setBulkMaterialMappings(null);
        setBulkFilterCompleted(false);
        setLoader(true);
        try {
          // Build action-specific fields to pass along to the API
          let partRecommendationRequest = null;
          let actionType = getActionType(selectedAction) || null;
          let priority = null;
          if (isPriorityAction(selectedAction)) {
            partRecommendationRequest = prepareHardwareApiPayload([], material[0].BundleId, material[0].AssetType);
            actionType = actionType || "BULK_CHANGE_PRIORITY";
            priority = Number(getActionValue(selectedAction).split("-")[1]);
          } else if (isDeleteAction(selectedAction)) {
            actionType = actionType || "BULK_DELETE";
          }
          const response = await ViewVehicleListByAddress(
            getActionValue(selectedAction),
            material[0].BundleId,
            props?.cspData?.data?.data?.CSP[0].CRM_Ref_ID,
            addressContactList,
            partRecommendationRequest,
            actionType,
            priority,
            props?.cspData?.data?.data?.CSP?.[0]?.Provider_Order,
            `${props?.cspData?.data?.data?.firstName} ${props?.cspData?.data?.data?.lastName}`,
            props?.cspData?.data?.data?.CSP?.[0]?.Opp_Sales_Org
          );
          if (response.status === 200 && response.data?.data?.vehicles) {
            setBulkVehiclesByAddress(response.data.data.vehicles);
            // Expand only the first accordion tab; others can be opened on click
            const materialIndex = productDetails.findIndex((m) => m[0]?.BundleId === selectedBundleIdForBulkAction);
            if (materialIndex !== -1) {
              setActiveIndex((prev) => {
                const newIndexes = [...prev];
                newIndexes[materialIndex] = [0];
                return newIndexes;
              });
            }
          } else {
            notify("Something went wrong, please try again.", "error");
            setTimeout(() => setNotification(null), 5000);
          }
        } catch {
          notify("Something went wrong, please try again.", "error");
          setTimeout(() => setNotification(null), 5000);
        } finally {
          setBulkFilterCompleted(true);
          setLoader(false);
        }
      };

      fetchFilteredVehicles();
    }
  }, [selectedAction]);
  const fetchFilteredVehiclesAddressChange = async (compositeKey) => {
    setBulkVehiclesByAddress({});
    setBulkMaterialMappings(null);
    setBulkFilterCompleted(false);
    setLoader(true);

    // Find the material for the selected bundle
    const material = productDetails.find((m) => m[0]?.BundleId === selectedBundleIdForBulkAction);
    if (!material) return;

    const shipGroups = material[0]?.shipGroups;
    if (!shipGroups || !shipGroups.length) return;

    const addressContactList = shipGroups.map((sg) => ({
      addressId: sg.addressId,
      contactId: sg.contactId,
    }));
    try {
      let actionType = getActionType(selectedAction) || null;
      let shippingAddressId = null;
      let installationAddressId = null;
      if (selectedAction.value === "change-shipping") {
        const foundAddress = (changeAddresses || []).find((addr) => addr.compositeKey === compositeKey);
        shippingAddressId = foundAddress?.addressId && String(foundAddress.addressId).includes("NEW-") ? null : foundAddress?.addressId || null;
      }

      if (selectedAction.value === "change-installation") {
        const foundAddress = (changeAddresses || []).find((addr) => addr.compositeKey === compositeKey);
        installationAddressId = foundAddress?.addressId && String(foundAddress.addressId).includes("NEW-") ? null : foundAddress?.addressId || null;
      }
      let contactInfoId = (changeAddresses || []).find((addr) => addr.compositeKey === compositeKey)?.contactId || null;
      // Also handle contactId if it contains "NEW-"
      if (contactInfoId && String(contactInfoId).includes("NEW-")) {
        contactInfoId = null;
      }
      let payload = {
        bundleId: material[0].BundleId,
        crmRefId: props?.cspData?.data?.data?.CSP[0].CRM_Ref_ID,
        addressContactList,
        ...(actionType ? { actionType } : {}),
        ...(shippingAddressId ? { shippingAddressId } : {}),
        ...(installationAddressId ? { installationAddressId } : {}),
        ...(contactInfoId ? { contactInfoId } : {}),
        providerOrderNumber: props?.cspData?.data?.data?.CSP?.[0]?.Provider_Order,
        modifiedBy: `${props?.cspData?.data?.data?.firstName} ${props?.cspData?.data?.data?.lastName}`,
        salesOrgId: props?.cspData?.data?.data?.CSP?.[0]?.Opp_Sales_Org,
      };
      const response = await ViewVehicleListByAddressOnly(payload);
      if (response.status === 200 && response.data?.data?.vehicles) {
        setBulkVehiclesByAddress(response.data.data.vehicles);
        // Expand only the first accordion tab; others can be opened on click
        const materialIndex = productDetails.findIndex((m) => m[0]?.BundleId === selectedBundleIdForBulkAction);
        if (materialIndex !== -1) {
          setActiveIndex((prev) => {
            const newIndexes = [...prev];
            newIndexes[materialIndex] = [0];
            return newIndexes;
          });
        }
      } else {
        notify("Something went wrong, please try again.", "error");
        setTimeout(() => setNotification(null), 5000);
      }
    } catch {
      notify("Something went wrong, please try again.", "error");
      setTimeout(() => setNotification(null), 5000);
    } finally {
      setBulkFilterCompleted(true);
      setLoader(false);
    }
  };

  const prepareHardwareApiPayload = (vehicles, vehicleBundleId, vehicleAssetType) => {
    const cspDataRoot = props?.cspData?.data?.data;
    if (!cspDataRoot) return null;

    const vehicleList = Array.isArray(vehicles) ? vehicles : vehicles ? [vehicles] : [];

    const products = cspDataRoot.Product || [];

    const coreProducts = products.filter(
      (product) =>
        product.BundleId === vehicleBundleId && product.featureType === "CORE" && product.AssetType.toLowerCase() === vehicleAssetType.toLowerCase()
    );

    if (!coreProducts.length) return null;

    const vinList = vehicleList.map((veh) => ({
      id: veh.id,
      vin: veh.vehicle,
      year: veh.year,
      make: veh.make,
      model: veh.model,
      killSwitch: veh.killSwitch,
      emergency: veh.emergency,
      wheelChair: veh.wheelChair,
      weightClass: veh.weightClass,
      fuelType: veh.fuelType,
    }));

    // Determine type from the first vehicle (default to "VEHICLE" when no vehicles provided)
    let type = "YMM";
    if (vehicleList.length > 0) {
      const firstVeh = vehicleList[0];
      type = firstVeh.vehicle?.startsWith("VIN") ? "YMM" : firstVeh.vehicle?.startsWith("AST") ? "ASSET" : "VEHICLE";
    } else if (vehicleAssetType.toLowerCase() === "asset") {
      type = "ASSET";
    }

    const payload = {
      vinList,
      type,
      countryCode: cspDataRoot.BillingCountry,
      salesOrgId: cspDataRoot.CSP?.[0]?.Opp_Sales_Org,
      productPlatform: cspDataRoot.ProductPlatform,
      accountBrand: cspDataRoot.Account_Brand,
      createdBy: `${cspDataRoot?.firstName} ${cspDataRoot?.lastName}`,
      vehicleSubscriptions: [],
    };
    const subscriptions = {};

    coreProducts.forEach((product) => {
      const subscription = product.SAPProductID;
      const techRefId = product.TechRefId;
      if (!subscriptions[subscription]) {
        subscriptions[subscription] = {
          subscription,
          techRefId,
          installTypeCore: product.InstallationType,
          vehicleFeatures: [],
        };
      }

      const features = products.filter(
        (p) => p.BundleId === product.BundleId && p.featureType === "FEATURE" && p.AssetType.toLowerCase() === vehicleAssetType.toLowerCase()
      );
      features.forEach((feature) => {
        subscriptions[subscription].vehicleFeatures.push({
          materialId: feature.SAPProductID,
          techRefId: feature.TechRefId,
          installTypeFeature: feature.InstallationType,
        });
      });
    });

    payload.vehicleSubscriptions = Object.values(subscriptions);
    return payload;
  };

  const handleTabChange = async (e, index, data, bundleId) => {
    // In bulk action mode, allow toggling accordion tabs (multiple mode)
    setActiveIndex((prev) => {
      const newIndexes = [...prev];
      newIndexes[index] = e.index; // e.index is an array of open tab indices in multiple mode
      return newIndexes;
    });

    if (!selectedAction) {
      productDetails.forEach((material, i) => {
        if (i !== index) {
          setActiveIndex((prev) => {
            const newIndexes = [...prev];
            newIndexes[i] = null;
            return newIndexes;
          });
        }
      });
    }
    if (!selectedAction && e.index !== null) {
      setVehicleList([]);
      setLoader(true);

      const response = await ViewVehicleList(
        bundleId,
        data[e.index].addressId,
        data[e.index].contactId,
        props?.cspData?.data?.data?.CSP[0].CRM_Ref_ID
      );
      if (response.status === 200 && response.data?.data) {
        setVehicleList(response.data?.data?.vehicles[`${bundleId}`]);
        setLoader(false);
      } else {
        setLoader(false);
        notify("Something went wrong, please try again.", "error");
        setTimeout(() => setNotification(null), 5000);
      }
    }
  };

  const handleClickOutside = () => {
    setNotification(null);
  };
  const clickRef = useOutsideClick(handleClickOutside);

  const getBundleList = async (payload) => {
    setLoader(true);
    let response = await bundleList(payload, props?.AccountID, props?.cspData?.data?.data?.CSP[0].CRM_Ref_ID);
    if (response.status === 200 && response.data?.data) {
      cspDetailsData.map((material) => {
        response.data?.data?.bundles.map((data) => {
          if (data.bundleId === material[0].BundleId) {
            material[0].vehicle = data.vehicle;
            material[0].shipGroups = data.shipGroups;
            material[0].vehicleIsPresent = data?.vehicleIsPresent;
            material[0].vin = data?.vin;
            material[0].deleteEligible = data?.deleteEligible;
          }
        });
      });
      cspDetailsData.map((material) => {
        if (material[0].vehicle) {
          const notEntered =
            Number(material[0].Quantity) -
            (Number(material[0].vehicle?.ready) + Number(material[0].vehicle?.warnings) + Number(material[0].vehicle?.completed));
          let displayString;
          if (notEntered > 0) {
            let parts = [];
            if (notEntered > 0) parts.push(`${notEntered} Remaining`);
            if (material[0].vehicle?.warnings > 0) parts.push(`${material[0].vehicle?.warnings} Needs Attention`);
            if (material[0].vehicle?.ready > 0) parts.push(`${material[0].vehicle?.ready} Ready`);
            displayString = parts.join("\u00A0\u00A0\u00A0\u00A0");
          } else {
            let parts = [];
            if (material[0].vehicle?.warnings > 0) parts.push(`${material[0].vehicle?.warnings} Needs Attention`);
            if (material[0].vehicle?.ready > 0) parts.push(`${material[0].vehicle?.ready} Ready`);
            displayString = parts.join("\u00A0\u00A0\u00A0\u00A0");
          }
          material[0].vehicle = { ...material[0].vehicle, displayString: displayString };
        }
      });
      let addresses = response.data?.data?.addresses || [];
      const createAddressCompositeKeys = (addresses) => {
        return addresses.map((address) => ({
          ...address,
          compositeKey: `${address.addressId}-${address.contactId}`,
        }));
      };
      const addressesWithKeys = createAddressCompositeKeys(addresses);
      setChangeAddresses((prevAddresses) => {
        // Create a map using spread operator for deduplication
        const addressMap = {
          // First spread existing addresses (user-created ones will be preserved)
          ...prevAddresses.reduce((acc, addr) => ({ ...acc, [addr.compositeKey]: addr }), {}),
          // Then spread API addresses (will overwrite existing ones with same key, but preserve NEW- ones)
          ...addressesWithKeys
            .filter((addr) => !addr.compositeKey.includes("NEW-")) // Don't overwrite user-created addresses
            .reduce((acc, addr) => ({ ...acc, [addr.compositeKey]: addr }), {}),
        };

        return Object.values(addressMap);
      });
      setProductDetails(cspDetailsData);
      setLoader(false);
    } else {
      setLoader(false);
      notify("Something went wrong, please try again.", "error");
      setTimeout(() => {
        setNotification(null);
      }, 5000);
    }
  };

  // Add this helper function to remove user-created addresses
  const removeUserCreatedAddresses = () => {
    setChangeAddresses((prevAddresses) => {
      // Filter out all addresses that contain "NEW-" in their composite keys
      return prevAddresses.filter((addr) => !addr.compositeKey.includes("NEW-"));
    });
  };

  const notify = (content, type) => {
    setNotification(<SLNotification key={generate()} type={type} title={content} fullBleed={true} ref={clickRef} />);
  };
  const editVehicle = (data, bundleName, bundleId, bundleData, assetType) => {
    let isEditable = true;
    if (data.vehicleStatus === "Warning" || data.changeVehicleEligible) {
      isEditable = true;
    } else {
      const allMaterialsSubmitted = data.materialMapping.every((material) => material.status.toLowerCase() === "submitted");
      if (allMaterialsSubmitted) {
        isEditable = false;
      }
    }

    if (isEditable) {
      handleAddPage(EditVehicleWTAMetadata.id, {
        data,
        bundleName,
        bundleId,
        bundleData,
        assetType,
      });
    }
  };

  const isVehicleEditable = (data) => {
    if (data.deviceType === DEVICE_TYPES.KEYFOB) {
      return false;
    }
    if (data.vehicleStatus === VEHICLE_STATUS.WARNING || data.changeVehicleEligible) {
      return true;
    }
    const allMaterialsSubmitted = data.materialMapping.every((material) => material.status.toLowerCase() === "submitted");
    return !allMaterialsSubmitted;
  };

  const deleteRow = (row, type) => {
    setDeleteModalOpened(true);
    setSelectedRecordForDelete({ row, type });
  };

  const closeDeleteModal = () => {
    setDeleteModalOpened(false);
    setSelectedRecordForDelete(null);
  };

  const handleConfirmDelete = async () => {
    setLoader(true);
    let response;
    if (
      selectedRecordForDelete.type === "Delete Vehicle" ||
      selectedRecordForDelete.type === "Delete Asset" ||
      selectedRecordForDelete.type === "Delete Key Fob"
    ) {
      let payload = {
        bundleId: null,
        crmRefId: props?.cspData?.data?.data?.CSP[0].CRM_Ref_ID,
        vinId: selectedRecordForDelete.row.id,
      };
      response = await deleteBundle(payload);
    }
    //bulk delete payload
    else if (selectedRecordForDelete.type === "Bulk Delete") {
      let payload = {
        bundleId: selectedRecordForDelete.row.BundleId,
        crmRefId: props?.cspData?.data?.data?.CSP[0].CRM_Ref_ID,
        vinId: null,
      };
      response = await deleteBundle(payload);
    }

    if (response.status === 200 && response.data?.data) {
      setDeleteModalOpened(false);
      setSelectedRecordForDelete(null);
      notify("Deleted successfully", "success");
      setTimeout(() => {
        setNotification(null);
      }, 5000);
      switchTab(1);
    } else {
      notify("Something went wrong, please try again.", "error");
      setTimeout(() => {
        setNotification(null);
      }, 5000);
    }
    setLoader(false);
  };

  const openModal = (assetType, bundleId, quantity, material) => {
    const notEntered =
      Number(quantity) - (Number(material[0].vehicle?.ready) + Number(material[0].vehicle?.warnings) + Number(material[0].vehicle?.completed));
    const falloutValue = Number(material[0].fallout) || 0;
    const availableQuantity = notEntered - falloutValue;
    const data = {};
    data.productInfo = material;
    data.availableQty = availableQuantity;
    assetType === "Vehicle" ? handleAddPage(AddVehicleAssignmentMetadata.id, data) : handleAddPage(AddAssetAssignmentMetadata.id, data);
  };

  const handleStartBulkAction = (bundleId) => {
    setSelectedBundleIdForBulkAction(bundleId);
    // fetch dropdowns for given bundle
    // save it in some place and pass to the component
  };
  // Track full vehicle objects per compositeKey so we can aggregate them correctly
  const [selectedVehiclesByKey, setSelectedVehiclesByKey] = useState({});

  const handleBulkVehicleSelection = (vehicles, compositeKey) => {
    setSelectedVehiclesByKey((prev) => {
      const updated = { ...prev, [compositeKey]: vehicles };
      // Flatten all vehicle objects across all compositeKeys
      const allVehicles = Object.values(updated).flat();
      setSelectedVehicles(allVehicles);
      return updated;
    });

    setSelectedVehicleIds((prev) => ({
      ...prev,
      [compositeKey]: vehicles.map((e) => e.id),
    }));
  };

  const handleBulkActionChange = (action) => {
    setSelectedAction(action);
    if (action?.value === "change-shipping") {
      setSelectedAddress(null);
      setShowChangeAddress(true);
      setTypeOfChangeAddress("shipping");
    } else if (action?.value === "change-installation") {
      setSelectedAddress(null);
      setShowChangeAddress(true);
      setTypeOfChangeAddress("installation");
    } else {
      setShowChangeAddress(false);
      setSelectedAddress(null); // Reset when not changing shipping
    }
    //show loader
    //make new vehicle details api call
    // store vehicle data here and render data based on them
  };
  const handleApplyAction = async () => {
    if (!selectedAction || !selectedVehicles.length) return;

    const material = productDetails.find((m) => m[0]?.BundleId === selectedBundleIdForBulkAction);
    if (!material) {
      notify("Bundle not found.", "error");
      setTimeout(() => setNotification(null), 5000);
      return;
    }

    const vehicleBundleId = material[0].BundleId;
    const vehicleAssetType = material[0].AssetType;
    const cspDataRoot = props?.cspData?.data?.data;

    setLoader(true);
    setApplyAction(true);
    try {
      if (isDeleteAction(selectedAction)) {
        // Delete vehicles: use actionType from the action-list API response
        const applyPayload = {
          actionType: getActionType(selectedAction) || "BULK_DELETE",
          modifiedBy: `${cspDataRoot?.firstName} ${cspDataRoot?.lastName}`,
          bundleId: vehicleBundleId,
          providerOrderNumber: cspDataRoot?.CSP?.[0]?.Provider_Order,
          crmRefId: cspDataRoot?.CSP?.[0]?.CRM_Ref_ID,
          vehicleIds: selectedVehicles.map((v) => Number(v.id)),
          salesOrgId: cspDataRoot?.CSP?.[0]?.Opp_Sales_Org,
        };

        const response = await postApplyActions(applyPayload);

        if (!response || response.status !== 200) {
          notify("Failed to delete the selected vehicles. Please try again.", "error");
          setTimeout(() => setNotification(null), 5000);
        } else {
          notify("Vehicles deleted successfully.", "success");
          setTimeout(() => setNotification(null), 5000);
        }
      } else if (isPriorityAction(selectedAction)) {
        // Priority actions: include partRecommendationRequest, conditionally include reasonForPriorityChange
        const partRecommendationRequest = prepareHardwareApiPayload(selectedVehicles, vehicleBundleId, vehicleAssetType);

        if (!partRecommendationRequest) {
          notify("Could not prepare payload for the selected vehicles.", "error");
          setTimeout(() => setNotification(null), 5000);
          return;
        }
        const priority = Number(getActionValue(selectedAction).split("-")[1]);

        const applyPayload = {
          actionType: getActionType(selectedAction) || "BULK_CHANGE_PRIORITY",
          modifiedBy: `${cspDataRoot?.firstName} ${cspDataRoot?.lastName}`,
          bundleId: vehicleBundleId,
          providerOrderNumber: cspDataRoot?.CSP?.[0]?.Provider_Order,
          crmRefId: cspDataRoot?.CSP?.[0]?.CRM_Ref_ID,
          vehicleIds: selectedVehicles.map((v) => Number(v.id)),
          priority,
          salesOrgId: cspDataRoot?.CSP?.[0]?.Opp_Sales_Org,
          ...(isPriorityActionWithReason(selectedAction) && selectedPriorityReason ? { reasonForPriorityChange: selectedPriorityReason } : {}),
          partRecommendationRequest,
        };

        const response = await postApplyActions(applyPayload);

        if (!response || response.status !== 200) {
          notify("Failed to process the selected vehicles. Please try again.", "error");
          setTimeout(() => setNotification(null), 5000);
        } else {
          notify("Priority action applied successfully.", "success");
          setTimeout(() => setNotification(null), 5000);
        }
      } else if (getActionType(selectedAction) === "BULK_CHANGE_ADDRESS") {
        let contactInfo, addressObject;

        let addressObj = (changeAddresses || []).find((addr) => addr.compositeKey === selectedAddress) || null;
        let addressId = addressObj?.addressId;
        if (addressId && String(addressId).includes("NEW-")) {
          contactInfo = {
            customerName: addressObj?.contactName || "",
            customerEmail: addressObj?.contactEmail || "",
            customerPhone: addressObj?.contactPhone || "",
            createdBy: `${cspDataRoot?.firstName} ${cspDataRoot?.lastName}`,
          };
          addressObject = {
            address1: addressObj?.address || "",
            address2: addressObj?.address1 || "",
            city: addressObj?.city || "",
            country: addressObj?.country || "",
            countryCode: addressObj?.countryCode || "",
            stateCode: addressObj?.stateCode || "",
            zipCode: addressObj?.zipCode || "",
            addressByPass: addressObj?.addressByPass || "",
            locationFound: addressObj?.locationFound || null,
            locusSuggestedAddress: addressObj?.locusSuggestedAddress || "",
            latitude: addressObj?.latitude || "",
            longitude: addressObj?.longitude || "",
            timezone: addressObj?.timezone || "",
            locusLocationId: addressObj?.locusLocationId || null,
            createdBy: addressObj?.createdBy || "",
            dpv: addressObj?.dpv || "",
            dpvDetails: addressObj?.dpvDetails || "",
          };
        } else {
          contactInfo = {
            contactId: addressObj?.contactId || "",
            customerName: addressObj?.contactName || "",
            customerEmail: addressObj?.contactEmail || "",
            customerPhone: addressObj?.contactPhone || "",
          };
          addressObject = {
            addressId: addressObj?.addressId || null,
            address1: addressObj?.address || "",
            address2: addressObj?.address1 || "",
            city: addressObj?.city || "",
            country: addressObj?.country || "",
            countryCode: addressObj?.countryCode || "",
            stateCode: addressObj?.stateCode || "",
            zipCode: addressObj?.zipCode || "",
            locusLocationId: addressObj?.locusLocationId || null,
            latitude: addressObj?.latitude || "",
            longitude: addressObj?.longitude || "",
            locusSuggestedAddress: addressObj?.locusSuggestedAddress || "",
            dpv: addressObj?.dpv || "",
            dpvDetails: addressObj?.dpvDetails || "",
          };
        }

        const applyPayload = {
          actionType: getActionType(selectedAction) || "BULK_CHANGE_ADDRESS",
          modifiedBy: `${cspDataRoot?.firstName} ${cspDataRoot?.lastName}`,
          bundleId: vehicleBundleId,
          providerOrderNumber: cspDataRoot?.CSP?.[0]?.Provider_Order,
          crmRefId: cspDataRoot?.CSP?.[0]?.CRM_Ref_ID,
          vehicleIds: selectedVehicles.map((v) => Number(v.id)),
          salesOrgId: cspDataRoot?.CSP?.[0]?.Opp_Sales_Org,
          ...(selectedAction?.value === "change-shipping" ? { shippingAddress: addressObject } : { installationAddress: addressObject }),
          contactInfo: contactInfo,
        };

        const response = await postApplyActions(applyPayload);

        if (!response || response.status !== 200) {
          notify("Failed to process the selected vehicles. Please try again.", "error");
          setTimeout(() => setNotification(null), 5000);
        } else {
          notify("Shipping address changed successfully.", "success");
          setTimeout(() => setNotification(null), 5000);
          removeUserCreatedAddresses();
        }
      }
    } catch {
      notify("Something went wrong while applying the action.", "error");
      setTimeout(() => setNotification(null), 5000);
    } finally {
      setLoader(false);
      setApplyAction(false);
    }

    // Reset bulk action state
    setSelectedAction(null);
    setSelectedBundleIdForBulkAction(null);
    setBulkVehiclesByAddress({});
    setBulkMaterialMappings(null);
    setBulkFilterCompleted(false);
    setSelectedPriorityReason("");
    setPriorityReasons([]);
    setSelectedVehicles([]);
    setSelectedVehicleIds({});
    setSelectedVehiclesByKey({});
    setActiveIndex([]); // Close all accordions when applying action
    setSelectedAddress(null); // Reset selected address
    setShowChangeAddress(false);
  };

  const handleAddressModalSave = (newAddress, contact) => {
    const newlyAddedAddress = {
      addressId: `NEW-${Date.now()}`,
      contactId: `NEW-CONTACT-${Date.now()}`,
      contactName: contact.contactName,
      contactPhone: contact.phone,
      contactEmail: contact.email,
      address: newAddress?.address1?.value || "",
      address1: newAddress?.address2?.value || "",
      city: newAddress?.city?.value || "",
      stateCode: newAddress?.state?.value?.erpStateCode || "",
      zipCode: newAddress?.zip?.value || "",
      country: newAddress?.country?.value?.description || "",
      countryCode: newAddress?.country?.value?.code || "",
      addressByPass: newAddress?.addressByPass || "",
      locationFound: newAddress?.locationFound || null,
      locusSuggestedAddress: newAddress?.locusSuggestedAddress || "",
      latitude: newAddress?.latitude || "",
      longitude: newAddress?.longitude || "",
      timezone: newAddress?.timezone || "",
      locusLocationId: newAddress?.locusLocationId || "",
      dpv: newAddress?.dpv || "",
      dpvDetail: newAddress?.dpvDetail || "",
      compositeKey: `${`NEW-${Date.now()}`}-NEW-CONTACT-${Date.now()}`,
    };
    const updatedAddresses = [...changeAddresses, newlyAddedAddress];
    setChangeAddresses(updatedAddresses);
    setSelectedAddress(newlyAddedAddress.compositeKey);
    resetContactDetails();
    fetchFilteredVehiclesAddressChange(newlyAddedAddress.compositeKey);
  };

  const handleAddressModalCancel = () => {
    resetContactDetails();
  };

  const resetContactDetails = () => {
    setIsAddressModalOpen(false);
  };

  const handleAddressChange = (compositeKey) => {
    setSelectedAddress(compositeKey);
    fetchFilteredVehiclesAddressChange(compositeKey);
  };
  const handleNewAddress = () => {
    setIsAddressModalOpen(true);
    if (typeOfChangeAddress === "shipping") {
      setAddressModalLabel("Select Shipping Information");
    } else {
      setAddressModalLabel("Select Installation Information");
    }
  };

  const renderVehicleList = (data) => {
    if (selectedAction && selectedBundleIdForBulkAction) {
      if (selectedAction.value === "change-shipping" || selectedAction.value === "change-installation") {
        if (selectedAddress) {
          return bulkVehiclesByAddress[`${data.addressId}-${data.contactId}`] || [];
        } else {
          return vehiclleList;
        }
      } else {
        return bulkVehiclesByAddress[`${data.addressId}-${data.contactId}`] || [];
      }
    } else {
      return vehiclleList;
    }
  };
  return (
    <>
      <Spacer top="10px" />
      <Breadcrumbs surface="light">
        <BreadcrumbItem key={0} active={false}>
          <span
            css={{
              fontWeight: "700",
              color: "black",
            }}
          >
            Assign Hardware
          </span>
        </BreadcrumbItem>
        <BreadcrumbItem key={1} active={false}>
          {"\u00A0"}
        </BreadcrumbItem>
      </Breadcrumbs>
      <Spacer top="1rem" />
      {notification}
      {isWTA && (
        <div style={{ width: "100%" }}>
          <OrderShippingSummaryAccordion></OrderShippingSummaryAccordion>
        </div>
      )}
      <Spacer top="1rem" />
      {infoModalOpened && <InfoModal isOpen={infoModalOpened} onClose={closeInfoModal} handleConfirmOk={closeInfoModal} assetType={assetType} />}
      <Loader active={isLoading} fullscreen />
      {isKeyFobsOpen && (
        <AddKeyFobsModal
          open={isKeyFobsOpen}
          close={(value, isSuccess = false) => {
            if (isSuccess) {
              getBundleList(materialBundleList);
            }
            setKeyFobsOpen(value);
          }}
          cspData={cspData}
          keyFobData={data}
          selectedKeyFobRow={selectedKeyFobRow}
        />
      )}

      {productDetails.map((material, index) => {
        if (selectedBundleIdForBulkAction && material[0].BundleId !== selectedBundleIdForBulkAction) {
          return null; // Hide other bundles
        }
        return (
          <React.Fragment key={index}>
            {selectedBundleIdForBulkAction === material[0].BundleId ? (
              // Render the bulk action design
              <div
                style={{
                  display: "flex",
                  backgroundColor: "black",
                  color: "white",
                  padding: "10px",
                  borderRadius: "5px",
                  marginBottom: "10px",
                  flexDirection: "row",
                }}
              >
                {/* Top Row: X Button and Bundle Name */}
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
                    <button
                      aria-label="Close bulk action bar"
                      onClick={() => {
                        setSelectedBundleIdForBulkAction(null);
                        setSelectedAction(null);
                        setBulkVehiclesByAddress({});
                        setBulkMaterialMappings(null);
                        setBulkFilterCompleted(false);
                        setSelectedPriorityReason("");
                        setPriorityReasons([]);
                        setActiveIndex([]); // Close all accordions when exiting bulk action mode
                        setSelectedAddress(null); // Reset selected address
                        setShowChangeAddress(false);
                      }}
                      style={{
                        background: "transparent",
                        border: "none",
                        padding: 0,
                        cursor: "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                      }}
                    >
                      <Icon name="close" size="small" color="#fff" aria-hidden="true" />
                    </button>
                    <span>
                      {material[0].BundleName} ({material[0].BundleId}) - <b>Bulk action in progress</b>
                    </span>
                  </div>{" "}
                  <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", gap: "12px" }}>
                    <CustomDropdownWithHeaders
                      setSelectedAction={handleBulkActionChange}
                      selectedAction={selectedAction}
                      notify={notify}
                      actionListPayload={{
                        actionType: "GET_SUPPORTED_ACTIONS",
                        modifiedBy: `${cspData?.firstName} ${cspData?.lastName}`,
                        bundleId: selectedBundleIdForBulkAction,
                        providerOrderNumber: cspData?.CSP?.[0]?.Provider_Order,
                        crmRefId: cspData?.CSP?.[0]?.CRM_Ref_ID,
                        salesOrgId: cspData?.CSP?.[0]?.Opp_Sales_Org,
                        addressContactList: (material[0]?.shipGroups || []).map((sg) => ({
                          addressId: sg.addressId,
                          contactId: sg.contactId,
                        })),
                        partRecommendationRequest: prepareHardwareApiPayload([], material[0].BundleId, material[0].AssetType),
                      }}
                    />
                    {showChangeAddress && (
                      <>
                        <div style={{ margin: "12px 0px" }}>To</div>
                        <AddressDropdown
                          options={changeAddresses}
                          placeholder={`Select the ${typeOfChangeAddress} information`}
                          selectedValue={selectedAddress}
                          onChange={handleAddressChange}
                          onAddNewAddress={handleNewAddress}
                          disabled={applyAction}
                        />
                      </>
                    )}
                    {/* Priority reason dropdown – shown only for priority-2 and priority-3 */}
                    {isPriorityActionWithReason(selectedAction) && (
                      <div>
                        <Dropdown
                          value={selectedPriorityReason}
                          options={priorityReasons}
                          onChange={(e) => setSelectedPriorityReason(e.value)}
                          optionLabel="description"
                          optionValue="id"
                          placeholder={isPriorityReasonsLoading ? "Loading reasons..." : "Select the reason"}
                          disabled={isPriorityReasonsLoading}
                          style={{
                            width: "280px",
                            height: "44px",
                            fontFamily: "Verizon-NHG-eDS",
                            fontSize: "16px",
                            fontWeight: 400,
                            lineHeight: "20px",
                            letterSpacing: "0.5px",
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>

                {/* Right-aligned section */}
                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginLeft: "auto" }}>
                  <span>Vehicles/Assets selected: {selectedVehicles.length}</span>
                  <Button
                    onClick={handleApplyAction}
                    size="small"
                    aria-label="Apply action"
                    role="button"
                    css={{
                      padding: "3px 0",
                      backgroundColor:
                        selectedAction && (!isPriorityActionWithReason(selectedAction) || selectedPriorityReason) && selectedVehicles.length > 0
                          ? "#fff"
                          : "#C4C4C4",
                      color: "black",
                      borderRadius: "16px",
                      height: "auto",
                      cursor:
                        selectedAction && (!isPriorityActionWithReason(selectedAction) || selectedPriorityReason) && selectedVehicles.length > 0
                          ? "pointer"
                          : "not-allowed",
                    }}
                    disabled={!selectedVehicles.length || !selectedAction || (isPriorityActionWithReason(selectedAction) && !selectedPriorityReason)}
                  >
                    Apply action
                  </Button>
                </div>
              </div>
            ) : (
              <>
                <FlexRow
                  css={{
                    backgroundColor: "black",
                    padding: "5px 0 5px 8px",
                    width: "100%",
                    fontSize: "14px",
                    color: "white",
                    borderRadius: "5px",
                    alignItems: "center",
                  }}
                >
                  <div css={{ fontWeight: 700, fontSize: "18px" }}>
                    {material[0].BundleName} ({material[0].BundleId})
                  </div>
                  {material[0].vehicle?.displayString == null ? (
                    <div css={{ marginLeft: "3rem" }}></div>
                  ) : (
                    <div css={{ marginLeft: "3rem" }}>{renderVehicleStatus(material)}</div>
                  )}

                  {/* Bulk delete functionality */}
                  <div style={{ display: "flex", marginLeft: "auto" }}>
                    {/* Start a Bulk Action Button */}
                    <Button
                      onClick={() => {
                        handleStartBulkAction(material[0].BundleId);
                      }}
                      size="small"
                      aria-label="Start a bulk action"
                      role="button"
                      css={{
                        display: "flex", // Use flexbox for alignment
                        alignItems: "center", // Align items vertically in the center
                        justifyContent: "center",
                        padding: "3px 0",
                        gap: "8px",
                        backgroundColor: "white",
                        borderRadius: "16px",
                        marginRight: "15px",
                        color: "black",
                        height: "auto",
                      }}
                    >
                      <img src={startBulk} width={14} height={14} style={{ marginRight: "4px", verticalAlign: "middle" }} />
                      <span style={{ display: "inline-block", lineHeight: "1" }}>Start a bulk Action</span>
                    </Button>
                    {/* {material[0]?.shipGroups?.length > 0 && Number(material[0]?.deleteEligible) > 0 ? (
                      <Button
                        onClick={() => {
                          deleteRow(material[0], "Bulk Delete");
                        }}
                        size="small"
                        aria-label="Delete Vehicle"
                        role="button"
                        css={{ padding: 0, backgroundColor: "white", borderRadius: "5px", marginLeft: "auto", marginRight: "15px", color: "black" }}
                      >
                        {material[0].AssetType === "Vehicle" ? "Delete Vehicles" : "Delete Assets"}
                      </Button>
                    ) : (
                      <Button
                        onClick={() => {}}
                        size="small"
                        aria-label="Delete Vehicle"
                        role="button"
                        css={{ padding: 0, backgroundColor: "#C4C4C4", borderRadius: "5px", marginLeft: "auto", marginRight: "15px", color: "black" }}
                        disabled={true}
                      >
                        {material[0].AssetType === "Vehicle" ? "Delete Vehicles" : "Delete Assets"}
                      </Button>
                    )} */}
                    {(() => {
                      const notEntered =
                        Number(material[0].Quantity) -
                        (Number(material[0].vehicle?.ready) + Number(material[0].vehicle?.warnings) + Number(material[0].vehicle?.completed));
                      const falloutValue = Number(material[0].fallout) || 0;
                      const isRemainingZero = notEntered - falloutValue <= 0;
                      return (
                        <Button
                          size="small"
                          aria-label="Add Vehicle"
                          role="button"
                          disabled={isRemainingZero}
                          css={{
                            padding: "3px 0",
                            display: "flex", // Use flexbox for alignment
                            alignItems: "center", // Align items vertically in the center
                            justifyContent: "center",
                            backgroundColor: isRemainingZero ? "#C4C4C4" : "white",
                            borderRadius: "16px",
                            marginRight: "1rem",
                            color: "black",
                            marginLeft: "auto",
                            height: "auto",
                          }}
                          onClick={() => {
                            openModal(material[0].AssetType, material[0].BundleId, material[0].Quantity, material);
                          }}
                        >
                          {material[0].AssetType === "Vehicle" ? "Add Vehicle & Address" : "Add Asset & Address"}
                        </Button>
                      );
                    })()}
                  </div>
                </FlexRow>
              </>
            )}
            {/* Bundle details */}
            {!selectedBundleIdForBulkAction ? (
              <>
                <Spacer top="15px" />
                <div css={{ width: "80%" }}>
                  <Table tabIndex={0} role="table" topLine="none" css={CustomTableHeader}>
                    <TableHead tabIndex={0} role="columnheader">
                      <TableHeader tabIndex={0} role="columnheader" width="9%">
                        <SmallText style={{ margin: "12px 0" }} bold>
                          Type
                        </SmallText>
                      </TableHeader>
                      <TableHeader tabIndex={0} role="columnheader" width="30%">
                        <SmallText style={{ margin: "12px 0" }} bold>
                          Subscription Name
                        </SmallText>
                      </TableHeader>
                      <TableHeader tabIndex={0} role="columnheader" width="14%">
                        <SmallText style={{ margin: "12px 0" }} bold>
                          Subscription ID
                        </SmallText>
                      </TableHeader>
                      <TableHeader tabIndex={0} role="columnheader" width="22%">
                        <SmallText style={{ margin: "12px 0" }} bold>
                          Tech-Ref ID
                        </SmallText>
                      </TableHeader>
                      <TableHeader tabIndex={0} role="columnheader" width="12%">
                        <SmallText style={{ margin: "12px 0" }} bold>
                          Order Type
                        </SmallText>
                      </TableHeader>
                      <TableHeader tabIndex={0} role="columnheader" width="9%">
                        <SmallText style={{ margin: "12px 0" }} bold>
                          Ordered
                        </SmallText>
                      </TableHeader>
                      <TableHeader tabIndex={0} role="columnheader" width="8%">
                        <SmallText style={{ margin: "12px 0" }} bold>
                          Fallout
                        </SmallText>
                      </TableHeader>
                      <TableHeader tabIndex={0} role="columnheader" width="13%">
                        <SmallText style={{ margin: "12px 0" }} bold>
                          Actions
                        </SmallText>
                      </TableHeader>
                    </TableHead>
                  </Table>
                  <Table role="table" topLine="none" striped={false} css={CustomTableHeader}>
                    <TableBody role="rowgroup">
                      {material.map((data, index) => {
                        return (
                          <TableRow role="row" key={data.materialId + index}>
                            <Cell tabIndex={0} role="cell" width="9%">
                              <SmallText css={{ margin: "12px 0" }}>{data.featureType}</SmallText>
                            </Cell>
                            <Cell tabIndex={0} role="cell" width="30%">
                              <SmallText css={{ margin: "12px 0" }}>{data.ProductName}</SmallText>
                            </Cell>
                            <Cell tabIndex={0} role="cell" width="14%">
                              <SmallText style={{ margin: "12px 0" }}>{data.SAPProductID}</SmallText>
                            </Cell>
                            <Cell tabIndex={0} role="cell" width="22%">
                              <SmallText style={{ margin: "12px 0" }}>{data.TechRefId}</SmallText>
                            </Cell>
                            <Cell tabIndex={0} role="cell" width="12%">
                              <SmallText style={{ margin: "12px 0" }}>{data.OrderDetailType}</SmallText>
                            </Cell>
                            <Cell tabIndex={0} role="cell" width="9%">
                              <SmallText style={{ margin: "12px 0" }}>{data.Quantity}</SmallText>
                            </Cell>
                            <Cell tabIndex={0} role="cell" width="8%">
                              <SmallText style={{ margin: "12px 0" }}>
                                {data.fallout !== null && data.fallout !== undefined && data.fallout > 0 ? data.fallout : "--"}
                              </SmallText>
                            </Cell>

                            <Cell tabIndex={0} role="cell" width="13%">
                              {data?.ProductName?.toLowerCase() === "key fob id" ? (
                                <TextLinkWrapper
                                  size="small"
                                  type="inline"
                                  tabIndex="0"
                                  role="link"
                                  style={{ fontSize: "12px", margin: "12px 0" }}
                                  disabled={!material[0]?.vehicleIsPresent}
                                  onClick={() => {
                                    setSelectedKeyFobRow({ ...data, vin: material[0]?.vin });
                                    validateKeyFobsQuantity({
                                      accountId: accountId,
                                      crmRefId: workTicketInfo?.workTicketInfo?.crmRefId,
                                      bundleId: data?.BundleId,
                                      maxQty: Number(data?.Quantity),
                                      type: "KEYFOB",
                                      kfbTechRefId: data?.TechRefId,
                                    });
                                  }}
                                >
                                  Assign To Address
                                </TextLinkWrapper>
                              ) : (
                                "--"
                              )}
                            </Cell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </div>
              </>
            ) : (
              <></>
            )}
            {/* <Spacer top="5px" /> */}{" "}
            <AccordionStyle>
              <Accordion
                expandIcon="pi pi-chevron-down"
                collapseIcon="pi pi-chevron-up"
                activeIndex={activeIndex[index]}
                // multiple={!!(selectedAction && selectedBundleIdForBulkAction)}
                multiple={false}
                onTabChange={(e) => {
                  handleTabChange(e, index, material[0].shipGroups, material[0].BundleId);
                }}
              >
                {material[0].shipGroups?.map((data) => {
                  const compositeKey = `${data.addressId}-${data.contactId}`;
                  const selectedCount = selectedVehicleIds[compositeKey]?.length || 0;
                  const vehicleData = renderVehicleList(data);
                  if (selectedAction && selectedBundleIdForBulkAction && vehicleData.length === 0) {
                    return <></>; // Don't render accordion tab if in bulk action mode and no vehicles for this address
                  }

                  return (
                    <AccordionTab
                      key={data.materialId}
                      iconPos="end"
                      headerTemplate={() => (
                        <div style={{ display: "flex", padding: "0.75rem", width: "100%" }}>
                          <div style={{ marginTop: "10px" }}>
                            <img src={onDemand} alt="ondemand-icon" width={20} height={20} />
                          </div>
                          <div style={{ paddingLeft: "1rem" }}>
                            <b>SHIPPING ADDRESS</b>
                            <div>
                              {formatAddress(data)} | <b>Contact:</b> {data.contactName}
                            </div>
                          </div>
                          {selectedBundleIdForBulkAction === material[0].BundleId && (
                            <div
                              style={{
                                fontSize: "12px",
                                color: selectedCount === 0 ? "#6f7171" : "#000",
                                fontWeight: 700,
                                opacity: selectedCount === 0 ? 0.6 : 1,
                                marginLeft: "auto",
                                marginTop: "12px",
                              }}
                              aria-disabled={selectedCount === 0}
                            >
                              Selected: {selectedCount}
                            </div>
                          )}
                        </div>
                      )}
                    >
                      {" "}
                      <AccordionTabContent
                        assetType={material[0].AssetType}
                        vehicleList={renderVehicleList(data)}
                        material={material}
                        data={data}
                        editVehicle={editVehicle}
                        isVehicleEditable={isVehicleEditable}
                        selectedBundleIdForBulkAction={selectedBundleIdForBulkAction}
                        deleteRow={deleteRow}
                        selectedAction={selectedAction}
                        handleBulkVehicleSelection={handleBulkVehicleSelection}
                        selectedVehicleIds={selectedVehicleIds}
                        selectedAddress={selectedAddress}
                      />
                    </AccordionTab>
                  );
                })}{" "}
              </Accordion>
              {/* Show message at bundle level when bulk action is active but no vehicles for any address */}
              {selectedAction &&
                selectedBundleIdForBulkAction === material[0].BundleId &&
                !isLoading &&
                bulkFilterCompleted &&
                (material[0].shipGroups || []).every((sg) => {
                  const vehicles = bulkVehiclesByAddress[`${sg.addressId}-${sg.contactId}`];
                  return !vehicles || vehicles.length === 0;
                }) && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "24px 16px",
                      color: "#6f7171",
                      fontSize: "14px",
                      fontFamily: "Verizon-NHG-eTX",
                      fontWeight: 500,
                    }}
                  >
                    No vehicles/assets available for the selected action.
                  </div>
                )}
            </AccordionStyle>
          </React.Fragment>
        );
      })}
      {deleteModalOpened && (
        <DeleteModal
          isOpen={deleteModalOpened}
          onClose={closeDeleteModal}
          title={selectedRecordForDelete?.type}
          row={selectedRecordForDelete?.row}
          handleConfirmDelete={handleConfirmDelete}
        />
      )}
      <AddressModal
        isOpen={isAddressModalOpen}
        label={addressModalLabel}
        typeofModal={typeOfChangeAddress}
        onSave={handleAddressModalSave}
        onCancel={handleAddressModalCancel}
      />
    </>
  );
};
export default AssignHardware;

export const AssignHardwareMetadata = {
  name: "Assign Hardware",
  id: "assign_hardware",
  component: lazy(() => import("./AssignHardware")),
  route: "/assign_hardware",
};
